import { useMemo } from 'react';

import { getEnv } from '../../lib/env';
import { getFlotiqMainPageUrl } from '../../lib/helpers';

export const useTopNav = () => {
  const mainItems = useMemo(
    () => [
      {
        key: 'features',
        label: 'Features',
        url: getFlotiqMainPageUrl('/features/'),
      },
      {
        key: 'solutions',
        label: 'Solutions',
        items: [
          {
            key: 'mobile',
            label: 'Mobile Apps',
            url: getFlotiqMainPageUrl('/solutions/mobile-apps/'),
          },
          {
            key: 'intranet',
            label: 'Intranet',
            url: getFlotiqMainPageUrl('/solutions/intranet/'),
          },
          {
            key: 'websites',
            label: 'Websites',
            url: getFlotiqMainPageUrl('/solutions/websites/'),
          },
        ],
      },
      {
        key: 'pricing',
        label: 'Pricing',
        url: getFlotiqMainPageUrl('/pricing/'),
      },
      {
        key: 'resources',
        label: 'Resources',
        items: [
          {
            key: 'blog',
            label: 'Blog',
            url: getFlotiqMainPageUrl('/blog/'),
          },
          {
            key: 'case-studies',
            label: 'Case studies',
            url: getFlotiqMainPageUrl('/case-studies/'),
          },
          {
            key: 'docs',
            label: 'Docs',
            url: getFlotiqMainPageUrl('/docs/'),
            newTab: true,
          },
          {
            key: 'faq',
            label: 'FAQ',
            url: getFlotiqMainPageUrl('/docs/faq/'),
            newTab: true,
          },
          {
            key: 'partners',
            label: 'Partners',
            url: getFlotiqMainPageUrl('/partners/'),
          },
          {
            key: 'starters',
            label: 'Starters',
            url: getFlotiqMainPageUrl('/starters/'),
          },
          {
            key: 'integrations',
            label: 'Integrations',
            url: getFlotiqMainPageUrl('/integrations/'),
          },
        ],
      },
    ],
    [],
  );

  const sideItems = useMemo(
    () => [
      {
        key: 'demo',
        label: 'Book a demo',
        url: getEnv('REACT_APP_FLOTIQ_CALCOM_URL'),
      },
      { key: 'login', label: 'Log in', url: '/login' },
    ],
    [],
  );

  return { topNav: { mainItems, sideItems } };
};
